import React, { Component, Fragment } from 'react'
import moment from 'lib/moment-timezone-custom'
import $ from 'lib/jquery'
import { HTTPError } from 'lib/ky'
import App from 'frontend/app'
import { reportError, reportMessage } from 'lib/report-error'
import InfiniteCalendar from 'react-infinite-calendar'
import RoomsSuggestionsModal from 'frontend/schedule/rooms-suggestions-modal'
import Legend from 'frontend/schedule/legend'
import ModalAlert from 'frontend/components/modal-alert'
import PromoCodeErrorModal from 'frontend/schedule/promo-code-error-modal'
import ProceedWithRoomModal from 'frontend/schedule/proceed-with-room-modal'
import AddedToCartModal from 'frontend/schedule/added-to-cart-modal'
import AddAnotherGameModal from 'frontend/schedule/add-another-game-modal'
import CalendarTheme from './calendar-theme'
import params from 'lib/params'
import conversion from 'frontend/lib/conversion/conversion-set'
import Order from 'models/order'
export default class ScheduleBase extends Component {
  constructor (props) {
    super(props)

    this.state = {
      cartItems: {},
    }

    this.handleHistoryPop = this.handleHistoryPop.bind(this)
  }

  componentDidMount () {
    addEventListener('popstate', this.handleHistoryPop)

    this.fetchOrder()
    this.updateSchedule()
  }

  componentDidUmount () {
    removeEventListener('popstate', this.handleHistoryPop)
  }

  handleHistoryPop ({ state }) {
    const newState = state || {}

    if (newState.selectedDate) newState.selectedDate = moment(newState.selectedDate)

    this.setState(Object.assign(Object.assign({}, this.initialState), state || {}), () => { this.updateSchedule() })
  }

  async fetchOrder ({ ...args } = {}) {
    const order = await App.currentOrder

    if (order) {
      App.currentOrder = order
      this.setState({ order })
      this.populateCartItems(order)
    }

    args.complete && args.complete()
  }

  updateSchedule () {
    throw new Error('ScheduleBase#updateSchedule: not implemented')
  }

  fetchSchedule (options = {}) {
    this.setState({ fetchingSchedule: true })

    $.ajax({
      type: 'get',
      url: options.url,
      data: options.data,
      error: (response) => {
        console.debug('ScheduleBase#fetchSchedule: error ' + options.url, response)

        this.setState({ errorMessage: 'Problem with fetching schedule from the server.' })
      },
      success: (response) => {
        options.success ? options.success(response) : console.warn('No callback given')
      },
      complete: () => {
        this.setState({ fetchingSchedule: false })
      },
    })
  }

  updateOrder (args) {
    let requestType = 'post'

    if (this.state.order && ['payment', 'cart'].includes(this.state.order.state)) { requestType = 'put' }

    let orderData = {
      prebookingCode: this.state.prebooking ? this.state.prebooking.code : '',
    }

    if (args.data) {
      orderData = Object.assign(orderData, args.data.order)
      delete args.data.order
    }

    const data = Object.assign(
      {
        order: Object.assign(
          {
            games_attributes: [
              {
                roomId: args.timeSlot.room.id,
                reservedTo: args.timeSlot.time.toISOString(),
                playersCount: this.state.selectedPlayersCount,
              },
            ],
          },
          orderData,
        ),
      },
      args.data || {},
    )

    $.ajax({
      type: requestType,
      url: '/order.json',
      data: JSON.stringify(data),
      error: (response) => {
        if (response.responseJSON && response.responseJSON) {
          const data = response.responseJSON
          if (data.error) {
            this.setState({ errorMessage: data.error })
          } else if (
            data.details?.games?.findIndex((e) => {
              return e.error === 'different_locations'
            }) > -1
            || data.details?.base?.findIndex((e) => {
              return e.error === 'games_items_mixed'
            }) > -1
          ) {
            this.setState({ showProceedWithRoomModal: true })
          } else if (data.errors && data.errors.promoCodeString) {
            this.setState({ promoCodeErrorMessages: data.errors.promoCodeString })
          } else if (data.errors) {
            const flatMessages = []

            for (const field in data.errors) {
              $(data.errors[field]).each(function (i, v) {
                flatMessages.push(v)
              })
            }

            this.setState({ errorMessage: flatMessages.join('; ') })
          }
        } else {
          if (response.readyState !== 0) {
            reportMessage('ScheduleBase#updateOrder', 'invalid response from server', response)
          }
          this.setState({ errorMessage: 'Sorry something went wrong' })
        }
        args.complete && args.complete()
      },
      success: (orderJson) => {
        const order = App.ensureIsOrder(orderJson)
        App.currentOrder = order
        this.populateCartItems(order)
        this.setState({ order, showAddedToOrderModal: true })
        this.sendAddToCartConversion(orderJson)
        args.complete && args.complete()
      },
    })
  }

  sendAddToCartConversion (orderJson) {
    const order = new Order({ attrs: orderJson })
    conversion.push({ type: 'event', event: 'add_to_cart', ...order.asConversion() })
  }

  populateCartItems (order) {
    const cartItems = {}

    if (['payment', 'cart'].includes(order.state)) {
      const gamesFromItems
        = order.items.filter(i => i.orderable_type === 'Game').map(i => i.orderable)

      order.games.concat(gamesFromItems).forEach((game) => {
        cartItems[game.reservedTo.valueOf() + '_' + game.roomId] = game
      })
    }

    this.setState({ cartItems })
  }

  redirectToOrder () {
    window.location = '/order/edit'
  }

  handleRemovePromoCode () {
    this.updateOrder({
      timeSlot: this.state.selectedSlot,
      data: { order: { promoCodeString: '' } },
    })
  }

  handleDateSelect (selectedDate) {
    selectedDate = this.constructor.ensureTzOffset(selectedDate)
    params.setWithHistory('selectedDate', selectedDate.format('YYYY-MM-DD'))
    this.setState({ selectedDate }, () => {
      this.updateSchedule()
    })
  }

  handleDaysLimitSelect (daysLimit) {
    params.setWithHistory('daysLimit', daysLimit)
    this.setState({ daysLimit }, () => {
      this.updateSchedule()
    })
  }

  handlePlayersCountSelect (playersCount, callback) {
    playersCount = parseInt(playersCount)
    playersCount = isNaN(playersCount) ? null : playersCount
    this.setState({ selectedPlayersCount: playersCount }, callback)
  }

  handleSlotSelect (args = {}) {
    if (args.timeSlot.time <= moment()) {
      args.complete && args.complete()
      return
    }

    if (args.timeSlot.room.multipleBookingsAllowed) {
      document.location = args.timeSlot.room.path
      return
    }

    this.setState({
      selectedPlayersCount: args.playersCount,
      selectedSlot: args.timeSlot,
      selectedRoom: args.timeSlot.room,
      selectedTime: args.timeSlot.time,
    })

    if (args.game) {
      this.redirectToOrder()
    } else if (args.timeSlot.status === 'available') {
      this.setState({}, () => { // wait for state update
        const playersCountCheck
          = this.state.selectedPlayersCount
            && args.timeSlot.room.minPlayers <= this.state.selectedPlayersCount
            && args.timeSlot.room.maxPlayers >= this.state.selectedPlayersCount

        if (playersCountCheck) {
          this.updateOrder(args)
        } else {
          args.complete && args.complete()
        }
      })
    } else {
      this.setState({
        unavailableSlot: args.timeSlot,
        showSuggestions: true,
      }, args.complete)
    }
  }

  async handleAddToCartInteractionsFinished (moreState = {}, callback) {
    this.setState(Object.assign({
      selectedPlayersCount: null,
      selectedSlot: null,
      selectedRoom: null,
      selectedTime: null,
      showAddedToOrderModal: false,
    }, moreState),
    callback,
    )
  }

  async handleGameRemove ({ game, timeSlot, complete }) {
    try {
      await this.removeFromOrder({ game, timeSlot })
    } catch (e) {
      await this.handleGameRemoveError(e)
    } finally {
      complete && complete()
    }
  }

  async removeFromOrder ({ game }) {
    await game.delete()
    const { order } = this.state
    order.games = order.games.filter(g => g.id !== game.id)
    this.populateCartItems(order)
    this.setState({ order })
  }

  async handleGameRemoveError (e) {
    if (e instanceof HTTPError && e.response.status === 404) {
      // Already removed, e.g. in another tab: show the cart the server has
      App.resetCurrentOrder()
      await this.fetchOrder()
    } else {
      reportError(e)
      this.setState({ errorMessage: 'Sorry something went wrong' })
    }
  }

  renderSuggestionsModal () {
    if (this.state.unavailableSlot) {
      return (
        <RoomsSuggestionsModal
          location={this.state.unavailableSlot.room.location}
          excludeRooms={[this.state.unavailableSlot.room]}
          time={this.state.unavailableSlot.time}
          playersCount={this.state.selectedPlayersCount}
          onSelect={this.handleSlotSelect.bind(this)}
          isOpen={this.state.showSuggestions}
          onClose={() => this.handleAddToCartInteractionsFinished({ showSuggestions: false })}
          onPlayersCountSelect={this.handlePlayersCountSelect.bind(this)}
        />
      )
    }

    return null
  }

  renderFilters () {
    return <div>Override me</div>
  }

  renderHelpers () {
    const calendarMax = moment().add(3, 'month').toDate()

    return (
      <div className="helpers">
        <div className="calendar">
          <InfiniteCalendar
            width="100%"
            height={220}
            theme={CalendarTheme}
            selected={this.state.selectedDate.toDate()}
            minDate={new Date()}
            min={new Date()}
            autoFocus={false}
            maxDate={calendarMax}
            max={calendarMax}
            onSelect={this.handleDateSelect.bind(this)}
            displayOptions={{ showTodayHelper: false }}
            tabIndex={0}
          />
        </div>
        <div className="seven_days_advance_banner">
          <div className="fix_wrap">Book 7 days in advance and save $10</div>
        </div>
        <Legend types={this.state.schedule.minPriceByType} />
        <div className="no_strangers_notice">
          *All games are private, only your team is allowed in the room, NO strangers.
        </div>
      </div>
    )
  }

  renderRefreshOverlay () {
    if (this.state.fetchingSchedule) {
      return (
        <div className="data_refresh_overlay">
          <div className="loading">
            <div className="spinner"></div>
          </div>
        </div>
      )
    }

    return null
  }

  renderNestedModal () {
    return null
  }

  renderSchedule () {
    return <div>Override me</div>
  }

  renderModals () {
    let modalAlert = null
    let promoCodeErrorModal = null
    let proceedWithRoomModal = null
    let addedToOrderModal = null
    let addAnotherModal = null

    if (this.state.errorMessage) {
      modalAlert = (
        <ModalAlert
          title="Error"
          body={this.state.errorMessage}
          onClose={() => {
            this.setState({ errorMessage: null })
          }}
        />
      )
    }

    if (this.state.promoCodeErrorMessages) {
      promoCodeErrorModal = (
        <PromoCodeErrorModal
          errors={this.state.promoCodeErrorMessages}
          onRemovePromoCode={this.handleRemovePromoCode.bind(this)}
          onClose={() => {
            this.setState({ promoCodeErrorMessages: null })
          }}
        />
      )
    }

    if (this.state.showProceedWithRoomModal) {
      proceedWithRoomModal = (
        <ProceedWithRoomModal
          onProceedWithPrevious={this.redirectToOrder.bind(this)}
          onClose={() => {
            this.setState({ showProceedWithRoomModal: false })
          }}
        />
      )
    }

    if (this.state.showAddedToOrderModal) {
      addedToOrderModal = (
        <AddedToCartModal
          onGoToCheckout={this.redirectToOrder.bind(this)}
          room={this.state.selectedRoom}
          time={this.state.selectedTime}
          onAddAnotherRoom={() => {
            this.setState({ showAddedToOrderModal: false, showAddAnotherModal: true })
          }}
          onClose={() => {
            this.handleAddToCartInteractionsFinished()
          }}
        />
      )
    }

    if (this.state.showAddAnotherModal && this.state.selectedSlot) {
      addAnotherModal = (
        <AddAnotherGameModal
          location={this.state.selectedSlot.room.location}
          // excludeRooms={this.state.games.filter(g => g.active).map(g => g.room)}
          time={this.state.selectedSlot.time}
          playersCount={this.state.selectedPlayersCount}
          isOpen={this.state.showAddAnotherModal}
          cartItems={this.state.cartItems}
          onSelect={this.handleSlotSelect.bind(this)}
          onClose={() => this.handleAddToCartInteractionsFinished({ showAddAnotherModal: false })}
          onPlayersCountSelect={(count, cb) => this.setState({ selectedPlayersCount: count }, cb)}
        />
      )
    }
    return (
      <Fragment>
        {modalAlert}
        {promoCodeErrorModal}
        {proceedWithRoomModal}
        {addedToOrderModal}
        {addAnotherModal}
        {this.renderNestedModal()}
        {this.renderSuggestionsModal()}
      </Fragment>
    )
  }

  renderScheduleBlocks () {
    return (
      <Fragment>
        {this.renderFilters()}
        {this.renderHelpers()}
        {this.renderSchedule()}
      </Fragment>
    )
  }

  render () {
    if (this.state.schedule) {
      return (
        <div className="schedule">
          {this.renderRefreshOverlay()}
          {this.renderModals()}
          {this.renderScheduleBlocks()}
        </div>
      )
    } else {
      return (
        <div className="schedule loading">
          {this.renderModals()}
          <div className="spinner"></div>
          Loading...
        </div>
      )
    }
  }

  static processRooms (rooms) {
    rooms.forEach(this.processRoom)
  }

  static processRoom (room) {
    room.dates.forEach(function (date) {
      date.timeSlots.forEach(function (timeSlot) {
        timeSlot.time = moment(timeSlot.time)
        timeSlot.room = room
      })
    })
  }

  static ensureTzOffset (date) {
    if (date instanceof Date) {
      return moment(date).add(date.getTimezoneOffset() * -1 - moment(date).utcOffset(), 'minutes')
    }

    return date
  }
}
